// extracted by mini-css-extract-plugin
export var root = "QsjK_ijJUZEun8BQ3vzs";